import { MaskAsDefaultEmailTemplateMeta, MaskAsDefaultEmailTemplatePayload } from 'types/store/MaskAsDefaultEmailTemplate';
import { createAsyncReducer } from 'utils/Redux';

import { maskAsDefaultEmailTemplateActions } from '../actions';

export default createAsyncReducer<MaskAsDefaultEmailTemplateMeta, MaskAsDefaultEmailTemplatePayload>(maskAsDefaultEmailTemplateActions);
